import { KeyValue } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomHttpHeaders } from 'cl-common-angular';
import { IUserAccount } from './user-account';

@Injectable({
    providedIn: 'root'
})
export class UserAccountService {
    private readonly routePrefix: string = '/api/userAccount/';

    constructor(private http: HttpClient) { }

    add = (userAccount: IUserAccount) => this.http.post<boolean>(this.routePrefix, userAccount, {
        headers: {
            [CustomHttpHeaders.suppressedErrorCodes]: '400'
        }
    })

    getAccountCreationSettings = () => this.http.get<KeyValue<string, any>[]>(`${this.routePrefix}`);

    checkUniqueness = (identifier: string, isStudentId: boolean) =>
        this.http.get<boolean>(`${this.routePrefix}checkuniqueness`,
            {
                params: {
                    identifier: identifier.toString(),
                    isStudentId: isStudentId.toString()
                },
                headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' })
            }
        )
}
